var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AvailabilityService } from "../../services/availability/availability.service";
import { AvailabilityExceptionService } from "../../services/availability/availabilityException.service";
import { addMinutes, diffInMinutes } from "../../utils/date.util";
// The fields of `edited` that differ from `original` (undefined and null count as the same)
export var pickSeriesChanges = function (original, edited) {
    var changes = {};
    var keys = ['type', 'name', 'color', 'capacityOverride', 'hidden', 'rrule'];
    keys.forEach(function (key) {
        var _a, _b;
        if (((_a = edited === null || edited === void 0 ? void 0 : edited[key]) !== null && _a !== void 0 ? _a : null) !== ((_b = original === null || original === void 0 ? void 0 : original[key]) !== null && _b !== void 0 ? _b : null)) {
            changes[key] = edited === null || edited === void 0 ? void 0 : edited[key];
        }
    });
    return changes;
};
export var updateSeriesFromOccurrence = function (_a) {
    var occurrence = _a.occurrence, newStart = _a.newStart, newEnd = _a.newEnd, _b = _a.changes, changes = _b === void 0 ? {} : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var series, diffStart, diffEnd, exception, exceptionChanges;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, AvailabilityService.getAvailabilityById(occurrence.availabilityId)];
                case 1:
                    series = _c.sent();
                    if (!series)
                        return [2 /*return*/];
                    diffStart = newStart ? diffInMinutes(newStart, occurrence.occurrenceStartTime) : 0;
                    diffEnd = newEnd ? diffInMinutes(newEnd, occurrence.occurrenceEndTime) : 0;
                    return [4 /*yield*/, AvailabilityService.updateAvailability(__assign(__assign(__assign({}, series), changes), { startTime: addMinutes(series.startTime, diffStart), endTime: addMinutes(series.endTime, diffEnd) }))];
                case 2:
                    _c.sent();
                    if (!occurrence.exceptionId)
                        return [2 /*return*/];
                    return [4 /*yield*/, AvailabilityExceptionService.getById(occurrence.exceptionId)];
                case 3:
                    exception = _c.sent();
                    if (!exception)
                        return [2 /*return*/];
                    exceptionChanges = __assign({}, changes);
                    delete exceptionChanges.rrule;
                    return [4 /*yield*/, AvailabilityExceptionService.update(__assign(__assign(__assign({}, exception), exceptionChanges), { 
                            // Occurrences of the series moved by the start shift - keep the exception on its day
                            originalStartTime: addMinutes(occurrence.occurrenceStartTime, diffStart), newStartTime: newStart !== null && newStart !== void 0 ? newStart : exception.newStartTime, newEndTime: newEnd !== null && newEnd !== void 0 ? newEnd : exception.newEndTime }))];
                case 4:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
};
